module.exports = __webpack_public_path__ + "img/a3.1053d45a.jpg";